export const SET_ENTITY = 'general-terms:set-entity';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/general-terms/action-types.js
 **/